export function countdownToEvent(eventDate: Date): { days: number; hours: number; minutes: number } {
  const currentDate: Date = new Date();
  const timeDifference: number = eventDate.getTime() - currentDate.getTime();

  if (timeDifference < 0) {
    return { days: 0, hours: 0, minutes: 0 }; // Event has already passed
  }

  const totalMinutes: number = Math.floor(timeDifference / (1000 * 60));
  const days: number = Math.floor(totalMinutes / (60 * 24));
  const hours: number = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes: number = Math.floor(totalMinutes % 60);

  return { days, hours, minutes };
}
